import { Box, Heading, Paragraph, Popover, Tag, Text } from '@zillow/constellation-10';
import { IconAwardRibbonFilled } from '@zillow/constellation-icons';

import { getActiveProductTypePremiumFeatures } from '../Freemium/components/FeaturesOfPremium/constants';

type Props = {
  size?: 'sm' | 'md';
  showIcon?: boolean;
  showWhatsIncluded?: boolean;
};

const PremiumTag = ({ size = 'md', showIcon = true, showWhatsIncluded = true }: Props) => {
  const icon = size === 'md' && showIcon ? <IconAwardRibbonFilled /> : undefined;

  if (!showWhatsIncluded) {
    return (
      <Tag tone="purple" size={size} icon={icon}>
        Premium
      </Tag>
    );
  }

  return (
    <Popover
      header={<Heading level={6}>What’s included</Heading>}
      body={
        <>
          {getActiveProductTypePremiumFeatures().map(({ heading, body }) => (
            <Box key={heading} css={{ marginBottom: '400' }}>
              <Text textStyle="body-bold" asChild>
                <p>{heading}</p>
              </Text>
              <Paragraph>{body}</Paragraph>
            </Box>
          ))}
        </>
      }
      trigger={
        <Popover.Trigger>
          <Tag asChild tone="purple" size={size} icon={icon} css={{ cursor: 'pointer' }}>
            <button type="button">Premium</button>
          </Tag>
        </Popover.Trigger>
      }
    />
  );
};

export default PremiumTag;
